import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Apollo, gql} from 'apollo-angular';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
import {notNull} from 'src/app/shared/utils';
import {
  ClientChatComponent_getClientChatroom,
  ClientChatComponent_getClientChatroomVariables,
} from './__generated__/ClientChatComponent_getClientChatroom';
import { catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/shared/services/error.service';

const GET_CLIENT_CHATROOM = gql`
  query ClientChatComponent_getClientChatroom($id: ID!) {
    me {
      id
    }
    user(id: $id) {
      chatRooms(isCoachRoom: true) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
`;

@Component({
  selector: 'app-client-chat',
  templateUrl: './client-chat.component.html',
  styleUrls: ['./client-chat.component.scss'],
})
export class ClientChatComponent implements OnInit, OnDestroy {
  currentUserId: string | null = null;
  chatroomId: string | null = null;
  subscription: Subscription | null = null;
  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private translate: TranslateService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    const clientId = notNull(this.route.parent).snapshot.params['id'];
    this.subscription = this.apollo
      .query<ClientChatComponent_getClientChatroom, ClientChatComponent_getClientChatroomVariables>(
        {
          query: GET_CLIENT_CHATROOM,
          variables: {id: clientId},
        },
      )
      .pipe(
        catchError(error => this.errorService.handleApollo(error))
      )
      .subscribe(
        output => {
          this.currentUserId = output.data.me.id;
          if (!output.data.user) {
            this.toastr.error(this.translate.instant('ERROR_NO_USER_DATA'));
            return;
          }

          if (!output.data.user.chatRooms.edges[0]) {
            this.toastr.error(this.translate.instant('ERROR_NO_CHATROOM_FOUND_FOR_USER'));
            return;
          }

          this.chatroomId = output.data.user?.chatRooms.edges[0].node.id;
        }
      );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
